<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
          <div class="mb-3 col-md-6">
            <div class="form-floating" >
              <input  v-model="form.lastname"  type="text" class="form-control" id="Nom" placeholder="Nom">
              <label for="Nom">Nom</label>
            </div>
            <div v-if="$v.form.lastname.$error" :class="$v.form.lastname.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.lastname.required"> Le champ est obligatoire.</div>
              <div class="error text-start" v-if="!$v.form.lastname.minLength">Le champ doit avoir au moins {{ $v.form.lastname.$params.minLength.min }} des lettres.</div>
            </div>
          </div>
          <div class="mb-3 col-md-6">
            <div class="form-floating" >
              <input  v-model="form.firname"  type="text" class="form-control" id="Prénom" placeholder="Prénom">
              <label for="Prénom">Prénom</label>
            </div>
            <div v-if="$v.form.firname.$error" :class="$v.form.firname.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.firname.required"> Le champ est obligatoire.</div>
              <div class="error text-start" v-if="!$v.form.firname.minLength">Le champ doit avoir au moins {{ $v.form.firname.$params.minLength.min }} des lettres.</div>
            </div>
          </div>
          <div class="mb-3 col-md-6">
            <datepicker  v-model="form.date"  :disabledDates="disabledDates" :language="fr" :bootstrap-styling="true" :wrapper-class="'form-floating'" placeholder="'A partir de'">
                <label slot="beforeDateInput" for="a-partir-de">A partir de</label>
            </datepicker>
            <div v-if="$v.form.date.$error" :class="$v.form.date.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.date.required"> Le champ est obligatoire.</div>
            </div>
          </div>
          <div class="mb-3 col-md-6">
            <div class="form-floating" >
              <input  v-model="form.nbparticipants"  min="1" type="number" class="form-control" id="nembre-des-accompagnes" placeholder="Nembre des accompagnes">
              <label for="nembre-des-accompagnes">Nembre des accompagnes</label>
            </div>
            <div v-if="$v.form.nbparticipants.$error" :class="$v.form.nbparticipants.$error ? ' c-invalid-feedback ' : ''">
              <div class="error text-start" v-if="!$v.form.nbparticipants.required"> Le champ est obligatoire.</div>
            </div>
          </div>

      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "./Date/Datepicker";
import {fr} from 'vuejs-datepicker/dist/locale'
import {validationMixin} from "vuelidate";
import {minLength, required} from "vuelidate/lib/validators";


export default {
  name: "Search",
  components: {
    Datepicker
  },
  data () {
    return {
      fr: fr,
      disabledDates: {
        customPredictor: function (date) {
          const d = new Date();
          if (date <= d) {
            return true
          }
        }
      },
      form: {
        lastname: null,
        firname: null,
        date: null,
        nbparticipants: 1,
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      lastname: {
        required,
        minLength: minLength(4)
      },
      firname: {
        required,
        minLength: minLength(4)
      },
      date: {
        required,
      },
      nbparticipants: {
        required
      },
    }
  },
  methods: {
    submit() {
      console.log('submit!')
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        this.$emit("do-search", {form: this.form})
      }
      return false;
    }
  }
}
</script>

